import { Line } from '../../../Common/Charts/Line';
import { useRegistersChartsDataContext } from './hooks/useRegistersChartsDataContext';

export const AnnualEvolutionRegisters = () => {
    const { chartData } = useRegistersChartsDataContext();

    return (
        <Line
            title={'Evolução anual do cadastramento'}
            subtitles={chartData?.annualEvolutionRegisters?.map(
                (item) => item.description
            )}
            values={[
                chartData?.annualEvolutionRegisters?.map(
                    (item) => item.novos_cadastros
                ),
                chartData?.annualEvolutionRegisters?.map(
                    (item) => item.atualizacoes
                ),
                chartData?.annualEvolutionRegisters?.map((item) => item.recusas)
            ]}
            category={['Novos Cadastros', 'Atualizações', 'Recusas']}
        />
    );
};
